<template>
  <div class="logindiv">
    <div class="logo">
      <img alt="logo" src="@/assets/Logo MOPE slo.svg" height="80">
    </div>
    <form novalidate @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="usernamediv">
        <div class="userpasspanel p-float-label p-input-icon-right">
          <i class="pi pi-envelope ikonaemail" />
          <InputText id="email" v-model="v$.username.$model" aria-describedby="email-error"/>
          <label for="email">Email*</label>
        </div>
      </div>
      <div class="errordiv">
        <small v-if="error && isChanged==false">{{ error }}</small>
      </div>
      <div class="submitbutton">
        <Button :label="translated('resetpassword')" @click="handleSubmit(!v$.$invalid)" />
        <div class="col-12 donthaveaccount">
          <a @click="goToLogin">{{ translated('backtologin') }}</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { computed } from "vue";
import store from "@/store";
import { email, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import router from "@/router";

export default {
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      username: '',
      submitted: false,
      isChanged: false,
      error: computed(() => store.state.error),
      translated: computed(() => store.getters.getTranslate)
    }
  },
  validations() {
    return {
      username: {
        required,
        email
      }
    }
  },
  created() { 
    store.dispatch("removeErrorMessage");
  },   
  methods: {
    async handleSubmit(isFormValid) {
      debugger;
      this.isChanged = false;
      this.submitted = true;
      if (!isFormValid) {
        return;
      }
      let model = {
        Username: this.username,
        Password: this.username
      };
      store.dispatch("resetPassword", model);
    },
    goToLogin() {
      router.push("login");
    }
  }
}
</script>

<style scoped>
.donthaveaccount {
  text-align: center;
  cursor: pointer;
}

form {
  background: white;
  padding: 20px;
  border-radius: 0 0 10px 10px;
}

form button {
  display: block;
  margin: 60px auto 0;
}

.logindiv .logo {
  padding: 10px;
  border-top: 2px solid white;
  border-left: 2px solid white;
  border-right: 2px solid white;
  display: flex;
  justify-content: center;
}

.userpasspanel {
  width: 100%;
}

.usernamediv {
  margin-top: 30px;
}

i.pi.pi-envelope.ikonaemail {
  top: 15px;
  right: 7px;
}
</style>